export const SERVICOS_PERMISSIONS = {
  servicesRead: 'services.read',
  servicesCreate: 'services.create',
  servicesUpdate: 'services.update',
  servicesDelete: 'services.delete',
  serviceOrdersRead: 'service_orders.read',
  serviceOrdersCreate: 'service_orders.create',
  serviceOrdersUpdate: 'service_orders.update',
  serviceOrdersDelete: 'service_orders.delete',
  serviceExecutionsRead: 'service_executions.read',
  serviceExecutionsCreate: 'service_executions.create',
  serviceExecutionsUpdate: 'service_executions.update',
  serviceExecutionsDelete: 'service_executions.delete',
} as const;
